import { setSpecificMessage, maxBytes } from "valibot";
setSpecificMessage(
  maxBytes,
  (issue) => `Octet invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);